import { makeStyles } from '@mui/styles';
const expandableSummaryStyles = makeStyles(({ palette: { common: { white, black }, text, }, }) => ({
    accordionRoot: {
        backgroundColor: white,
        '&': {
            '&:before': {
                opacity: 0,
            },
        },
    },
    accordionSummary: {
        padding: 0,
        background: white,
        margin: '12px 0 22px',
        '&': {
            '&.Mui-expanded': {
                minHeight: 'fit-content',
            },
        },
    },
    accordionSummaryContent: {
        margin: 0,
    },
    summaryTitle: {
        margin: 0,
        fontWeight: 'bold',
        color: text.primary,
    },
    accordionDetails: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        border: 'initial',
    },
    expandIcon: {
        color: black,
        display: 'flex',
    },
    expandIconContainer: {
        position: 'absolute',
        right: -5,
    },
}), { name: 'Common_ExpandableSummary' });
export default expandableSummaryStyles;
//# sourceMappingURL=expandableSummary.styles.js.map